import { DealRolePermissions, DealRoleType } from "@/src/graphql/generated";
import { classNames } from "@/src/utils/cn";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { DealPermissionsSummary } from "./DealPermissionsSummary";

export function DealRoleName(props: {
  name: string;
  roleType: DealRoleType;
  permissions: DealRolePermissions;
  className?: string;
}) {
  const triggerRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!open || !triggerRef.current) {
      return;
    }

    const updatePosition = () => {
      if (!triggerRef.current) {
        return;
      }
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top - 6,
        left: rect.left,
      });
    };

    updatePosition();
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);
    return () => {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
    };
  }, [open]);

  return (
    <>
      <span
        ref={triggerRef}
        className={classNames(
          "inline-flex cursor-default border-b border-dotted border-concrete-300 text-sm font-medium text-persian-990",
          props.className ?? "",
        )}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        {props.name}
      </span>
      {open
        ? createPortal(
            <div
              className="pointer-events-none fixed z-[9999] max-w-sm -translate-y-full rounded-md border border-concrete-200 bg-white p-2 shadow-lg"
              style={{ top: position.top, left: position.left }}
            >
              <DealPermissionsSummary
                permissions={props.permissions}
                roleType={props.roleType}
              />
            </div>,
            document.body,
          )
        : null}
    </>
  );
}
